module.exports = __webpack_public_path__ + "static/media/chief-Human-centric.d364f1e2.png";